import { Field, Formik } from "formik";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
import Post from "../../api/Post";
import Put from "../../api/Put";
import {
  ACCOUNT_ACTIVE_ALL,
  CHECK_EXPEDIENTE_DUPLICADO,
  COUNTRY_ACTIVE_ALL,
  GET_EPS,
  GET_LOCALIDADES,
  GET_OCUPACION,
  GET_PROPERTY_TYPES,
  GET_ROAD_TYPE,
  LANGUAGE_ACTIVE_ALL,
  MUNICIPIO_LIST,
  PACIENTERELACION_GET_ACTIVE,
  PACIENTES_ADD,
  PACIENTES_EDIT,
  PACIENTE_BUSCAR,
  PACIENTE_UPDATE,
  STATES_LIST,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
} from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import DatePicker from "react-datepicker";
import PhoneInput from "react-phone-input-2";
import es from "react-phone-input-2/lang/es.json";
import { FaInfo } from "react-icons/fa";
import Get from "../../api/Get";
import SimpleLoad from "../../loader/SimpleLoad";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import Select from "react-select";
import { isDoctor } from "../../utils/isDoctor";
import { isConsultorio } from "../../utils/isConsultorio";
import ModalText from "../ModalText";

function FormPatientColombia({ t, id, edit, isNew }) {
  const [loading, setLoading] = useState(edit);
  const [isGeneratedCita, setIsGenerateCita] = useState("editar");
  const { auth } = useContext(authContext);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [gender, setGender] = useState("");
  const [dateOfBirthday, setDateOfBirthday] = useState(null);
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");
  const [accountsAll, setAccountsAll] = useState([]);
  const [accountDefault, setAccountdefault] = useState(null);
  const [partnerDefault, setPartnerDefault] = useState("");
  const [countryOpt, setCountryOpt] = useState([]);
  const [countryBirthOpt, setCountryBirthOpt] = useState([]);
  const [languageOpt, setLanguageOpt] = useState([]);
  const [tipoSangre, setTipoSangre] = useState("");

  const [estadoOpt, setEstadoOpt] = useState([]);
  const [municipioOpt, setMunicipioOpt] = useState([]);
  const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([]);
  const [dataSend, setDataSend] = useState(null);
  const [showModalExpediente, setShowModalExpediente] = useState(false);
  const [noExpediente, setNoExpediente] = useState("");
  const [submitingA, setSubmitingA] = useState(false);
  
  // Expediente duplication check states
  const [expedienteDuplicado, setExpedienteDuplicado] = useState(false);
  const [checkingExpediente, setCheckingExpediente] = useState(false);

  const handleClose = () => setShow(false);
  const handleCloseExpediente = () => setShowModalExpediente(false);

  const [estadoDefault, setEstadoDefault] = useState(null);
  const [municipioDefault, setMunicipioDefault] = useState(null);
  const [paisDefault, setPaisDefault] = useState(null);

  const [tipoPacientes, setTipoPacientes] = useState([]);

  //aditional directions
  const [roadTypes, setRoadTypes] = useState([]);
  const [roadTypesDefault, setRoadTypesDefault] = useState(null);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertyTypesDefault, setPropertyTypesDefault] = useState(null);
  const [propertyTypesAdicionalDefault, setPropertyTypesAdicionalDefault] =
    useState(null);

  //error server
  const [showModalError, setShowModalError] = useState(false);
  const [errorServer, setErrorServer] = useState(null);
  const handleCloseServer = () => setShowModalError(false);

  const [locationDefault, setLocationDefault] = useState(null);
  const [localidadesOpt, setLocalidadesOpt] = useState([]);
  const [ocupacionDefault, setOcupacionDefault] = useState(null);
  const [ocupacionOpt, setOcupacionOpt] = useState([]);

  const [loadPaciente, setLoadPaciente] = useState(false);
  const [modalEncontro, setModalEncontro] = useState(false);

  const [epsDefault, setEpsDefault] = useState(null);
  const [epsOpt, setEpsOpt] = useState([]);

  const initColombusA = {
    id: "",
    roadType: null,
    streetField1: "",
    streetField2: "",
    streetField3: "",
    propertyNumber: "",
    propertyType: null,
    propertyTypeAdditional: null,
    unitNumber: "",
  };

  const [initialValues, setInitialValues] = useState({
    id: "",
    name: "",
    middleName: "",
    seccondSurname: "",
    lastName: "",
    gender: "",
    dateOfBirthday: "",
    phoneNumber: "",
    email: "",
    account: "",
    partner: "",
    identityDocumentType: "",
    documentNumber: "",
    country: "",
    bloodType: "",
    ocupacion: "",
    address: "",
    language: "",
    municipio: "",
    state: "",
    localidad: "",
    neighborhood: "",
    nationality: "",
    patientRelationship: "",
    colombusAddress: initColombusA,
    countryBirth: "",
    eps: {
      id: "",
      nombreEps: "",
      codigo: "",
    },
  });

  const [hasLength, setHasLength] = useState(10);
  const [idTipoDocumento, setIdTipoDocumento] = useState(null);
  const getLengthDN = (code) => {
    switch (code.toUpperCase()) {
      case "CE":
        return 12;
      case "CD":
      case "PA":
      case "SC":
        return 16;
      case "PE":
        return 15;
      case "RC":
      case "TI":
        return 11;
      case "CN":
        return 9;
      case "MS":
        return 12;
      default:
        return 10;
    }
  };

  const getTipoDocumento = (value) => {
    let arr = tipoDocumentoOpt
      .filter((el) => el.code === "AS" || el.code === "MS")
      .map((e) => e.id);
    return arr.includes(parseInt(value));
  };

  const shemaValidate = Yup.object().shape({
    name: Yup.string().required(t("Camporequerido")),
    lastName: Yup.string().required(t("Camporequerido")),
    patientRelationship: Yup.string().required(t("Camporequerido")),
    gender: Yup.string().required(t("Camporequerido")),
    dateOfBirthday: Yup.string().required(t("Camporequerido")),
    phoneNumber: Yup.string().required(t("Camporequerido")),
    phoneNumber2: Yup.string().required(t("Camporequerido")),
    email: Yup.string()
      .email(t("Correoinvalido"))
      .required(t("Camporequerido")),
    account: Yup.string().required(t("Camporequerido")),
    identityDocumentType: Yup.string().required(t("Camporequerido")),
    documentNumber: Yup.string().when("identityDocumentType", {
      is: (value) => getTipoDocumento(value),
      then: Yup.string().required(t("Camporequerido")),
      otherwise: Yup.string()
        .required(t("Camporequerido"))
        .min(5, `Debe tener una longitud mínima de 5 caracteres`)
        .max(
          hasLength,
          `Debe tener una longitud máxima de ${hasLength} caracteres`
        ),
    }),
    country: Yup.string().required(t("Camporequerido")),
    countryBirth: Yup.string().required(t("Camporequerido")),
    bloodType: Yup.string().required(t("Camporequerido")),
    ocupacion: Yup.string().required(t("Camporequerido")),
    language: Yup.string().required(t("Camporequerido")),
    //municipio: Yup.string().required(t("Camporequerido")),
    localidad: Yup.string().when("municipio", {
      is: (value) => value !== "2633",
      then: Yup.string().notRequired(),
      otherwise: Yup.string().required(t("Camporequerido")),
    }),
    //state: Yup.string().required(t("Camporequerido")),
    nationality: Yup.string().required(t("Camporequerido")),
    colombusAddress: Yup.object().shape({
      //roadType: Yup.string().required(t("Camporequerido")),
      //streetField1: Yup.string().required(t("Camporequerido")),
      //streetField2: Yup.string().required(t("Camporequerido")),
      //streetField3: Yup.string().required(t("Camporequerido")),
    }),
    eps: Yup.object().shape({
      id: Yup.number().required(t("Camporequerido")),
    }),
  });

  const generarCita = (valor) => {
    setIsGenerateCita(valor);
  };

  useEffect(() => {
    Get({ url: ACCOUNT_ACTIVE_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setAccountsAll(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: COUNTRY_ACTIVE_ALL, noToken: true })
      .then((response) => {
        setCountryOpt(
          response.data.data.response.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
        setCountryBirthOpt(
          response.data.data.response.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: LANGUAGE_ACTIVE_ALL, access_token: auth.data.access_token })
      .then((response) => {
        setLanguageOpt(response.data);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({
      url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setTipoDocumentoOpt(response.data);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({
      url: PACIENTERELACION_GET_ACTIVE,
      access_token: auth.data.access_token,
    })
      .then((response) => {
        setTipoPacientes(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    //direccion de clb
    Get({ url: GET_ROAD_TYPE, access_token: auth.data.access_token })
      .then((response) => {
        setRoadTypes(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_PROPERTY_TYPES, access_token: auth.data.access_token })
      .then((response) => {
        setPropertyTypes(response.data.data.response);
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_LOCALIDADES, access_token: auth.data.access_token })
      .then((response) => {
        if (response.data.state) {
          setLocalidadesOpt(
            response.data.data.response.map((el) => ({
              label: el.nombreLocalidad,
              value: el.id,
            }))
          );
        }
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_OCUPACION, access_token: auth.data.access_token })
      .then((response) => {
        if (response.data.state) {
          setOcupacionOpt(
            response.data.data.response.map((el) => ({
              label: el.nombreOcupacion,
              value: el.id,
            }))
          );
        }
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    //eps
    Get({ url: GET_EPS, access_token: auth.data.access_token })
      .then((response) => {
        //console.log(response)
        if (response.data.state) {
          setEpsOpt(
            response.data.data.response.map((el) => ({
              label: el.nombreEps,
              value: el.id,
            }))
          );
        }
      })
      .catch((error) => {
        setShowModalError(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  }, []);

  //si cambia el pais
  const [paisNacimientoDefault, setPaisNacimientoDefault] = useState(null);
  const [idCountry, setIdCountry] = useState(null);
  useEffect(() => {
    if (idCountry) {
      Get({
        url: `${STATES_LIST}/${idCountry}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setEstadoOpt(
            response.data.data.response.map((el) => ({
              label: el.name,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setEstadoOpt([]);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      setEstadoOpt([]);
    }
  }, [idCountry]);

  //si cambia el estado
  const [idEstado, setIdEstado] = useState(null);
  useEffect(() => {
    if (idEstado) {
      Get({
        url: `${MUNICIPIO_LIST}/${idEstado}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setMunicipioOpt(
            response.data.data.response.map((el) => ({
              label: el.dsMunDel,
              value: el.id,
            }))
          );
        })
        .catch((error) => {
          setMunicipioOpt([]);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      setMunicipioOpt([]);
    }
  }, [idEstado]);

  //si cambia el account para q sepa cual es el partner==="cliente corporativo"
  useEffect(() => {
    if (accountDefault) {
      let itemsF = accountsAll.filter((el) => el.id === accountDefault.value);
      if (itemsF.length) {
        setPartnerDefault(itemsF[0].partner.name);
      }
    }
  }, [accountDefault]);

  useEffect(() => {
    if (id) {
      Get({
        url: `${PACIENTES_EDIT}/${id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          //console.log(response)
          let colombusA = initColombusA;
          if (response.data.colombusAddress) {
            //console.log('entro')
            colombusA.id = response.data.colombusAddress.id;
            colombusA.roadType = response.data.colombusAddress.roadType
              ? response.data.colombusAddress.roadType.id
              : null;
            colombusA.streetField1 = response.data.colombusAddress.streetField1;
            colombusA.streetField2 = response.data.colombusAddress.streetField2;
            colombusA.streetField3 = response.data.colombusAddress.streetField3;
            colombusA.propertyNumber =
              response.data.colombusAddress.propertyNumber;
            colombusA.propertyType = response.data.colombusAddress.propertyType
              ? response.data.colombusAddress.propertyType.id
              : null;
            colombusA.propertyTypeAdditional = response.data.colombusAddress
              .propertyTypeAdditional
              ? response.data.colombusAddress.propertyTypeAdditional.id
              : null;
            colombusA.unitNumber = response.data.colombusAddress.unitNumber;

            if (response.data.colombusAddress.roadType) {
              setRoadTypesDefault({
                value: response.data.colombusAddress.roadType.id,
                label: response.data.colombusAddress.roadType.name,
              });
            }
            if (response.data.colombusAddress.propertyType) {
              setPropertyTypesDefault({
                value: response.data.colombusAddress.propertyType.id,
                label: response.data.colombusAddress.propertyType.name,
              });
            }
            if (response.data.colombusAddress.propertyTypeAdditional) {
              setPropertyTypesAdicionalDefault({
                value: response.data.colombusAddress.propertyTypeAdditional.id,
                label:
                  response.data.colombusAddress.propertyTypeAdditional.name,
              });
            }
          }
          let entity = {
            id: response.data.id,
            name: response.data.name ? response.data.name : "",
            middleName: response.data.middleName
              ? response.data.middleName
              : "",
            seccondSurname: response.data.seccondSurname
              ? response.data.seccondSurname
              : "",
            lastName: response.data.lastName ? response.data.lastName : "",
            gender: response.data.gender ? response.data.gender : "",
            dateOfBirthday: response.data.dateOfBirthday
              ? new Date(moment(response.data.dateOfBirthday, "DD-MM-YYYY"))
              : "",
            phoneNumber: response.data.phoneNumber
              ? response.data.phoneNumber
              : "",
            phoneNumber2: response.data.phoneNumber2
              ? response.data.phoneNumber2
              : "",
            email: response.data.email,
            account: response.data.account ? response.data.account.id : "",
            partner: response.data.account
              ? response.data.account.partner.id
              : "",
            identityDocumentType: response.data.identityDocumentType
              ? response.data.identityDocumentType.id
              : "",
            documentNumber: response.data.documentNumber
              ? response.data.documentNumber
              : "",
            country: response.data.country ? response.data.country.id : "",
            bloodType: response.data.bloodType ? response.data.bloodType : "",
            ocupacion: response.data.ocupacion
              ? response.data.ocupacion.id
              : "",
            address: response.data.address ? response.data.address : "",
            language: response.data.language ? response.data.language.id : "",
            municipio: response.data.municipio
              ? response.data.municipio.id
              : null,
            state: response.data.state ? response.data.state.id : null,
            localidad: response.data.localidad
              ? response.data.localidad.id
              : "",
            neighborhood: response.data.neighborhood
              ? response.data.neighborhood
              : "",
            nationality: response.data.nationality
              ? response.data.nationality
              : "",
            patientRelationship: response.data.patientRelationship
              ? response.data.patientRelationship.id
              : "",
            colombusAddress: colombusA,
            countryBirth: response.data.countryBirth
              ? response.data.countryBirth.id
              : "",
            eps: response.data.eps
              ? response.data.eps
              : {
                  id: "",
                  nombreEps: "",
                  codigo: "",
                },
          };
          setPhone(response.data.phoneNumber);
          setPhone2(response.data.phoneNumber2);
          setPartnerDefault(
            response.data.account ? response.data.account.partner.name : ""
          );
          setAccountdefault({
            label: response.data.account.name,
            value: response.data.account.id,
          });
          setGender(response.data.gender);
          setIdCountry(response.data.country?.id);
          if (response.data.country) {
            setPaisDefault({
              label: response.data.country.name,
              value: response.data.country.id,
            });
          }
          if (response.data.state) {
            setEstadoDefault({
              label: response.data.state.name,
              value: response.data.state.id,
            });
            setIdEstado(response.data.state.id);
          }
          if (response.data.municipio) {
            setMunicipioDefault({
              label: response.data.municipio.dsMunDel,
              value: response.data.municipio.id,
            });
          }
          if (response.data.countryBirth) {
            setPaisNacimientoDefault({
              label: response.data.countryBirth.name,
              value: response.data.countryBirth.id,
            });
          }
          setDateOfBirthday(
            response.data.dateOfBirthday
              ? new Date(moment(response.data.dateOfBirthday, "DD-MM-YYYY"))
              : null
          );
          //console.log(entity)
          setInitialValues(entity);
          setTipoSangre(response.data.bloodType);
          if (response.data.localidad) {
            setLocationDefault({
              label: response.data.localidad.nombreLocalidad,
              value: response.data.localidad.id,
            });
          }
          setOcupacionDefault({
            label: response.data.ocupacion?.nombreOcupacion,
            value: response.data.ocupacion?.id,
          });

          if (response.data.eps) {
            setEpsDefault({
              label: response.data.eps.nombreEps,
              value: response.data.eps.id,
            });
          }

          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  // Check expediente duplication when expediente changes
  useEffect(() => {
    // Don't check if expediente is empty
    if (!noExpediente || noExpediente.trim() === '') {
      setExpedienteDuplicado(false)
      return
    }

    // Debounce: Wait 500ms after user stops typing
    const timeoutId = setTimeout(() => {
      setCheckingExpediente(true)
      Get({
        url: `${CHECK_EXPEDIENTE_DUPLICADO}/${noExpediente.trim()}`,
        access_token: auth.data.access_token
      })
      .then(response => {
        setCheckingExpediente(false)
        // API returns { expediente: "9768235", existe: false }
        // existe: true means it exists (duplicated), existe: false means not duplicated
        const isDuplicated = response.data.existe === true || response.data.data?.existe === true
        setExpedienteDuplicado(isDuplicated)
      })
      .catch(error => {
        setCheckingExpediente(false)
        // On error, allow submission (don't block user)
        setExpedienteDuplicado(false)
        console.error('Error checking expediente:', error)
      })
    }, 500) // 500ms debounce

    return () => clearTimeout(timeoutId)
  }, [noExpediente, auth.data.access_token])

  const sendAutoAgendamiento = () => {
    // Prevent submission if expediente is duplicated
    if (expedienteDuplicado) {
      return
    }
    setSubmitingA(true);
    dataSend["expediente"] = noExpediente;

    if (edit && id) {
      Put({
        url: PACIENTE_UPDATE,
        data: dataSend,
        access_token: auth.data.access_token,
        header: true,
      })
        .then((response) => {
          setSubmitingA(false);
          setShowModalExpediente(false);
          if (response) {
            setShow(true);
            setTimeout(() => {
              setShow(false);
              if (isDoctor(auth.data.role)) {
                history.replace(`/admin/doctors/patients`);
              } else {
                history.replace("/admin/patients");
              }
            }, 4000);
          }
        })
        .catch((error) => {
          setSubmitingA(false);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      Post({
        url: PACIENTES_ADD,
        data: dataSend,
        access_token: auth.data.access_token,
        header: true,
      })
        .then((response) => {
          setSubmitingA(false);
          if (response) {
            setShowModalExpediente(false);
            setShow(true);
            setTimeout(() => {
              setShow(false);
              history.replace("/admin/patients");
            }, 5000);
          }
        })
        .catch((error) => {
          setSubmitingA(false);
          setShowModalError(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    }
  };

  async function fetchNumeroDocumento(documento, idTD) {
    if (documento && idTD) {
      let result = [];
      const data = {
        documentNumber: documento,
        identityDocumentType: { id: idTD },
      };
      const response = await Post({
        url: PACIENTE_BUSCAR,
        data: data,
        access_token: auth.data.access_token,
        header: true,
      });
      if (!response.data.state) {
        return result;
      } else {
        result.push(response.data.data);
        return result;
      }
    } else {
      return [];
    }
  }

  const handleBlur = (e, error) => {
    if (e.target.value !== "" && error === undefined) {
      setLoadPaciente(true);
      try {
        async function fetchClientExist() {
          //checamos el numero de documento
          const resp = await fetchNumeroDocumento(
            e.target.value,
            idTipoDocumento
          );
          if (resp.length > 0) {
            const findPatient = resp[resp.length - 1];
            let initColombusA = {
              id: "",
              roadType: findPatient.colombusAddress?.roadType?.id ?? "",
              streetField1: findPatient.colombusAddress?.streetField1 ?? "",
              streetField2: findPatient.colombusAddress?.streetField2 ?? "",
              streetField3: findPatient.colombusAddress?.streetField3 ?? "",
              propertyNumber: findPatient.colombusAddress?.propertyNumber ?? "",
              propertyType: findPatient.colombusAddress?.propertyType,
              propertyTypeAdditional:
                findPatient.colombusAddress?.propertyTypeAdditional,
              unitNumber: findPatient.colombusAddress?.unitNumber ?? "",
            };
            //console.log(resp)
            setInitialValues((prev) => ({
              ...prev,
              id: findPatient.id,
              name: findPatient.name,
              middleName: findPatient.middleName ?? "",
              seccondSurname: findPatient.seccondSurname ?? "",
              lastName: findPatient.lastName ?? "",
              gender: findPatient.gender ?? "",
              dateOfBirthday: findPatient.dateOfBirthday ?? "",
              phoneNumber: findPatient.phone,
              phoneNumber2: findPatient.phone2,
              email: findPatient.email,
              account: findPatient.account ? findPatient.account.id : "",
              partner: findPatient.account
                ? findPatient.account.partner.id
                : "",
              identityDocumentType: findPatient.identityDocumentType?.id ?? "",
              documentNumber: findPatient.documentNumber,
              country: findPatient.country?.id ?? "",
              bloodType: findPatient.bloodType,
              ocupacion: findPatient.ocupacion?.id ?? "",
              ocupacion_name: findPatient.ocupacion?.name ?? "",
              language: findPatient.languageDTO?.id ?? "",
              municipio: findPatient.municipio?.id ?? "",
              state: findPatient.state?.id ?? "",
              localidad: findPatient.localidad?.id ?? "",
              neighborhood: findPatient.neighborhood,
              nationality: findPatient.nationality
                ? findPatient.nationality
                : "",
              patientRelationship: findPatient.patientRelationshipDTO?.id ?? "",
              colombusAddress: initColombusA,
              countryBirth: findPatient.countryBirth?.id ?? "",
              eps: findPatient.eps?.id
                ? { id: findPatient.eps?.id, nombreEps: findPatient.eps?.name }
                : null,
            }));
            setDateOfBirthday(
              findPatient.dateOfBirthday
                ? new Date(moment(findPatient.dateOfBirthday, "DD-MM-YYYY"))
                : null
            );
            setPhone(findPatient.phone);
            setPhone2(findPatient.phone2);
            setGender(findPatient?.gender ?? "");
            setTipoSangre(findPatient?.bloodType ?? "");
            setPaisNacimientoDefault({
              value: findPatient.countryBirth?.id ?? "",
              label: findPatient.countryBirth?.name,
            });
            setPaisDefault({
              value: findPatient.country?.id ?? "",
              label: findPatient.country?.name,
            });
            setEstadoDefault({
              value: findPatient.state?.id ?? "",
              label: findPatient.state?.name,
            });
            setMunicipioDefault({
              value: findPatient.municipio?.id ?? "",
              label: findPatient.municipio?.dsMunDel,
            });
            setLocationDefault({
              value: findPatient.localidad?.id ?? "",
              label: findPatient.localidad?.name,
            });
            setOcupacionDefault({
              value: findPatient.ocupacion?.id ?? "",
              label: findPatient.ocupacion?.name,
            });
            setRoadTypesDefault({
              value: findPatient.colombusAddress?.roadType?.id ?? "",
              label: findPatient.colombusAddress?.roadType?.name,
            });
            setPropertyTypesDefault({
              value: findPatient.colombusAddress?.propertyType?.id ?? "",
              label: findPatient.colombusAddress?.propertyType?.name,
            });
            setPropertyTypesAdicionalDefault({
              value:
                findPatient.colombusAddress?.propertyTypeAdditional?.id ?? "",
              label: findPatient.colombusAddress?.propertyTypeAdditional?.name,
            });
            if (findPatient.account) {
              setAccountdefault({
                value: findPatient.account.id,
                label: findPatient.account.name,
              });
            }
            setEpsDefault(
              findPatient.eps
                ? {
                    value: findPatient.eps?.id ?? "",
                    label: findPatient.eps?.name,
                  }
                : null
            );

            setModalEncontro(true);
          }
          setLoadPaciente(false);
        }
        fetchClientExist();
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Row>
      {loadPaciente && <LoadingList texto={"Buscando paciente"} />}
      {id && loading ? (
        <LoadingList texto={t("cargando_datos")} />
      ) : (
        <Col>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={shemaValidate}
            onSubmit={(values, { setSubmitting, setFieldValue }) => {
              //console.log(values)
              //setSubmiting(true)
              //formar el colombus adress
              let cAdrress = {
                id: values.colombusAddress.id,
                roadType: values.colombusAddress.roadType
                  ? roadTypes
                      .filter((e) => e.id === values.colombusAddress.roadType)
                      .map((e) => ({ id: e.id, name: e.name }))[0]
                  : null,
                streetField1: values.colombusAddress.streetField1,
                streetField2: values.colombusAddress.streetField2,
                streetField3: values.colombusAddress.streetField3,
                propertyNumber: values.colombusAddress.propertyNumber,
                propertyType: values.colombusAddress.propertyType
                  ? propertyTypes
                      .filter(
                        (e) => e.id === values.colombusAddress.propertyType
                      )
                      .map((e) => ({ id: e.id, name: e.name }))[0]
                  : null,
                propertyTypeAdditional: values.colombusAddress
                  .propertyTypeAdditional
                  ? propertyTypes
                      .filter(
                        (e) =>
                          e.id === values.colombusAddress.propertyTypeAdditional
                      )
                      .map((e) => ({ id: e.id, name: e.name }))[0]
                  : null,
                unitNumber: values.colombusAddress.unitNumber,
              };
              //console.log(cAdrress)
              let d = {
                id: values.id,
                name: values.name,
                middleName: values.middleName,
                seccondSurname: values.seccondSurname,
                lastName: values.lastName,
                gender: values.gender,
                dateOfBirthday: moment(
                  values.dateOfBirthday,
                  "DD-MM-YYYY"
                ).format("DD-MM-YYYY"),
                phoneNumber: values.phoneNumber,
                phoneNumber2: values.phoneNumber2,
                email: values.email,
                account: { id: values.account },
                identityDocumentType: { id: values.identityDocumentType },
                documentNumber: values.documentNumber,
                country: { id: values.country },
                bloodType: values.bloodType,
                ocupacion: { id: values.ocupacion },
                address: values.address,
                language: { id: values.language },
                municipio: values.municipio ? { id: values.municipio } : null,
                state: values.state ? { id: values.state } : null,
                localidad: { id: values.localidad },
                neighborhood: values.neighborhood,
                nationality: values.nationality,
                autoagendamiento: isGeneratedCita === "automatico",
                patientRelationship: { id: values.patientRelationship },
                colombusAddress: cAdrress,
                countryBirth: { id: values.countryBirth },
                eps: values.eps,
              };

              //console.log(d)
              setSubmitting(false);
              if (d.autoagendamiento) {
                setSubmitting(false);
                setDataSend(d);
                setShowModalExpediente(true);
              } else {
                if (edit && id) {
                  Put({
                    url: PACIENTE_UPDATE,
                    data: d,
                    access_token: auth.data.access_token,
                    header: true,
                  })
                    .then((response) => {
                      setSubmitting(false);
                      if (response) {
                        if (isGeneratedCita === "manual") {
                          history.replace(
                            `/admin/create-appointment/${response.data.id}`
                          );
                        } else if (isGeneratedCita === "automatico") {
                          setShow(true);
                          setTimeout(() => {
                            setShow(false);
                            if (
                              isDoctor(auth.data.role) ||
                              isConsultorio(auth.data.role)
                            ) {
                              history.replace(`/admin/doctors/patients`);
                            } else {
                              history.replace("/admin/patients");
                            }
                          }, 5000);
                        } else {
                          if (
                            isDoctor(auth.data.role) ||
                            isConsultorio(auth.data.role)
                          ) {
                            history.replace(`/admin/doctors/patients`);
                          } else {
                            history.replace("/admin/patients");
                          }
                        }
                      }
                    })
                    .catch((error) => {
                      setSubmitting(false);
                      setShowModalError(true);
                      if (error.response) {
                        setErrorServer(error.response);
                      }
                    });
                } else {
                  Post({
                    url: PACIENTES_ADD,
                    data: d,
                    access_token: auth.data.access_token,
                    header: true,
                  })
                    .then((response) => {
                      //console.log(response)
                      setSubmitting(false);
                      if (response) {
                        if (isGeneratedCita === "manual") {
                          history.replace(
                            `/admin/create-appointment/${response.data.data.id}`
                          );
                        } else if (isGeneratedCita === "automatico") {
                          setShow(true);
                          setTimeout(() => {
                            setShow(false);
                            if (
                              isDoctor(auth.data.role) ||
                              isConsultorio(auth.data.role)
                            ) {
                              history.replace(`/admin/doctors/patients`);
                            } else {
                              history.replace("/admin/patients");
                            }
                          }, 5000);
                        } else {
                          if (
                            isDoctor(auth.data.role) ||
                            isConsultorio(auth.data.role)
                          ) {
                            history.replace(`/admin/doctors/patients`);
                          } else {
                            history.replace("/admin/patients");
                          }
                        }
                      }
                    })
                    .catch((error) => {
                      setSubmitting(false);
                      setShowModalError(true);
                      if (error.response) {
                        setErrorServer(error.response);
                      }
                    });
                }
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldError,
            }) => (
              <Form onSubmit={handleSubmit} className="mt-3">
                {isSubmitting && <LoadingList texto="Procesando petición" />}
                <input type="hidden" name="id" value={values.id} />
                <Card className="shadow-1">
                  <Card.Body>
                    <h4 className="text-color-4">{t("Datosgenerales")}</h4>
                    <Row>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("tipo_documento")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${
                              errors.identityDocumentType && "error"
                            }`}
                            name="identityDocumentType"
                            onChange={(e) => {
                              setFieldValue(
                                "identityDocumentType",
                                e.target.value
                              );
                              if (e.target.value !== "") {
                                setIdTipoDocumento(parseInt(e.target.value));
                                let aux = tipoDocumentoOpt.filter(
                                  (el) => el.id === parseInt(e.target.value)
                                )[0];
                                setHasLength(getLengthDN(aux.code));
                              } else {
                                setIdTipoDocumento(null);
                              }
                            }}
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {tipoDocumentoOpt.map((item, i) => (
                              <option
                                value={item.id}
                                key={i}
                              >{`${item.code} : ${item.name}`}</option>
                            ))}
                          </Field>
                          {errors.identityDocumentType && (
                            <div className="invalid-feedback d-block">
                              {errors.identityDocumentType}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="5">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("documento_identidad")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${
                              errors.documentNumber && "error"
                            }`}
                            onBlur={(e) => handleBlur(e, errors.documentNumber)}
                            name="documentNumber"
                          />
                          {errors.documentNumber && (
                            <div className="invalid-feedback d-block">
                              {errors.documentNumber}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Nombre")} <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase ${
                              errors.name && "error"
                            }`}
                            name="name"
                            onChange={(e) => {
                              setFieldValue(
                                "name",
                                e.target.value.toUpperCase()
                              );
                            }}
                          />
                          {errors.name && (
                            <div className="invalid-feedback d-block">
                              {errors.name}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Segundo nombre
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase`}
                            name="middleName"
                            onChange={(e) => {
                              setFieldValue(
                                "middleName",
                                e.target.value.toUpperCase()
                              );
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Primer Apellido{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase ${
                              errors.lastName && "error"
                            }`}
                            name="lastName"
                            onChange={(e) => {
                              setFieldValue(
                                "lastName",
                                e.target.value.toUpperCase()
                              );
                            }}
                          />
                          {errors.lastName && (
                            <div className="invalid-feedback d-block">
                              {errors.lastName}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Segundo Apellido
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form text-uppercase`}
                            name="seccondSurname"
                            onChange={(e) => {
                              setFieldValue(
                                "seccondSurname",
                                e.target.value.toUpperCase()
                              );
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Tipo <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${
                              errors.patientRelationship && "error"
                            }`}
                            name="patientRelationship"
                          >
                            <option value="">Seleccionar</option>
                            {tipoPacientes.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.patientRelationship && (
                            <div className="invalid-feedback d-block">
                              {errors.patientRelationship}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("sexo")} <span className="text-danger">*</span>
                          </Form.Label>
                          <ul className="mb-0 list-inline list-form">
                            <li
                              className={`${
                                gender === "Female" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setGender("Female");
                                setFieldValue("gender", "Female");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Femenino")}
                              </span>
                            </li>
                            <li
                              className={`${
                                gender === "Male" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setGender("Male");
                                setFieldValue("gender", "Male");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Masculino")}
                              </span>
                            </li>
                            <li
                              className={`${
                                gender === "NotSpecified" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setGender("NotSpecified");
                                setFieldValue("gender", "NotSpecified");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                No especificado
                              </span>
                            </li>
                          </ul>
                          {errors.gender && (
                            <div className="invalid-feedback d-block">
                              {errors.gender}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary d-block">
                            {t("fecha_nacimiento")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <DatePicker
                            className={`form-control input-form w-100 ${
                              errors.dateOfBirthday && "error"
                            }`}
                            selected={dateOfBirthday}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            onChange={(date) => {
                              if (date === null) {
                                setDateOfBirthday(null);
                                setFieldValue("dateOfBirthday", "");
                              } else {
                                setDateOfBirthday(date);
                                setFieldValue("dateOfBirthday", date);
                              }
                            }}
                          />
                          {errors.dateOfBirthday && (
                            <div className="invalid-feedback d-block">
                              {errors.dateOfBirthday}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Entidad Promotora de Salud (EPS){" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${errors.eps && "error"}`}
                            options={epsOpt}
                            defaultValue={epsDefault}
                            value={epsDefault}
                            onChange={(value) => {
                              //console.log(value)
                              setEpsDefault(value);
                              setFieldValue("eps.id", value.value);
                              setFieldValue("eps.nombreEps", value.label);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.eps?.id && (
                            <div className="invalid-feedback d-block">
                              {errors.eps?.id}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Nacionalidad")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <div className="mt-3">
                            <label className="mr-5 text-color-input">
                              Colombiana
                              <Field
                                type="radio"
                                name="nationality"
                                value="Colombiana"
                                className="ml-3 radio-form"
                                onChange={(e) => {
                                  setFieldValue("nationality", "Colombiana");
                                  let p = countryOpt.filter(
                                    (el) =>
                                      el.label.toLowerCase() === "colombia"
                                  );
                                  if (p.length > 0) {
                                    if (values.country !== p[0].value) {
                                      setFieldValue("country", p[0].value);
                                      setPaisDefault({
                                        label: p[0].label,
                                        value: p[0].value,
                                      });
                                      setMunicipioOpt([]);
                                      setFieldValue("municipio", "");
                                      setIdCountry(p[0].value);

                                      setFieldValue("countryBirth", p[0].value);
                                      setPaisNacimientoDefault({
                                        label: p[0].label,
                                        value: p[0].value,
                                      });
                                    }
                                  }
                                }}
                              />
                            </label>
                            <label className="mr-5 text-color-input">
                              {t("Extranjera")}
                              <Field
                                type="radio"
                                name="nationality"
                                value="Extranjera"
                                className="ml-3 radio-form"
                              />
                            </label>
                          </div>
                          {errors.nationality && (
                            <div className="invalid-feedback d-block">
                              {errors.nationality}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="shadow-1 my-5">
                  <Card.Body>
                    <h4 className="text-color-4">Otros datos</h4>
                    <Row>
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Telefono")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <PhoneInput
                            inputClass={`form-control input-form ${
                              errors.phoneNumber && "error"
                            } w-100`}
                            country={"co"}
                            countryCodeEditable={false}
                            enableSearch={true}
                            preferredCountries={["co", "mx"]}
                            disableSearchIcon={true}
                            localization={es}
                            value={phone}
                            onChange={(phone, country, e, formattedValue) => {
                              setPhone(phone);
                              setFieldValue("phoneNumber", phone);
                              let validNumber =
                                country.format.match(/\./g).length;
                              if (phone.length !== validNumber) {
                                setFieldError("phoneNumber", "Campo inválido");
                              } else if (phone.length === validNumber) {
                                setFieldValue("phoneNumber", phone, true);
                              }
                            }}
                          />
                          {errors.phoneNumber && (
                            <div className="invalid-feedback d-block">
                              {errors.phoneNumber}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Teléfono alterno{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <PhoneInput
                            inputClass={`form-control input-form ${
                              errors.phoneNumber2 && "error"
                            } w-100`}
                            country={"co"}
                            countryCodeEditable={false}
                            enableSearch={true}
                            preferredCountries={["co", "mx"]}
                            disableSearchIcon={true}
                            localization={es}
                            value={phone2}
                            onChange={(phone, country, e, formattedValue) => {
                              setPhone2(phone);
                              setFieldValue("phoneNumber2", phone);
                              let validNumber =
                                country.format.match(/\./g).length;
                              if (phone.length !== validNumber) {
                                setFieldError("phoneNumber2", "Campo inválido");
                              } else if (phone.length === validNumber) {
                                setFieldValue("phoneNumber2", phone, true);
                              }
                            }}
                          />
                          {errors.phoneNumber2 && (
                            <div className="invalid-feedback d-block">
                              {errors.phoneNumber2}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Correoelectronico")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form ${
                              errors.email && "error"
                            }`}
                            name="email"
                          />
                          {errors.email && (
                            <div className="invalid-feedback d-block">
                              {errors.email}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                          País de nacimiento
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${
                              errors.countryBirth && "error"
                            }`}
                            options={countryBirthOpt}
                            defaultValue={paisNacimientoDefault}
                            value={paisNacimientoDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setPaisNacimientoDefault(value);
                              setFieldValue("countryBirth", value.value);
                            }}
                            placeholder="Escoger opción"
                            isDisabled={values.nationality === "Colombiana"}
                          />
                          {errors.countryBirth && (
                            <div className="invalid-feedback d-block">
                              {errors.countryBirth}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                          País de residencia
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${
                              errors.country && "error"
                            }`}
                            options={countryOpt}
                            defaultValue={paisDefault}
                            value={paisDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setPaisDefault(value);
                              setFieldValue("country", value.value);
                              setMunicipioOpt([]);
                              setFieldValue("municipio", "");
                              setMunicipioDefault(null);
                              setFieldValue("state", "");
                              setEstadoDefault(null);
                              setIdCountry(value.value);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.country && (
                            <div className="invalid-feedback d-block">
                              {errors.country}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("departamento")}{" "}
                          </Form.Label>
                          <Select
                            className={`input-form ${errors.state && "error"}`}
                            options={estadoOpt}
                            defaultValue={estadoDefault}
                            value={estadoDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setEstadoDefault(value);
                              setFieldValue("state", value.value);
                              setFieldValue("municipio", "");
                              setMunicipioDefault(null);
                              setMunicipioOpt([]);
                              setIdEstado(value.value);
                              setFieldValue("localidad", "");
                              setLocationDefault(null);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.state && (
                            <div className="invalid-feedback d-block">
                              {errors.state}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="3">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Ciudad
                          </Form.Label>
                          <Select
                            className={`input-form ${
                              errors.municipio && "error"
                            }`}
                            options={municipioOpt}
                            defaultValue={municipioDefault}
                            value={municipioDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setMunicipioDefault(value);
                              setFieldValue("municipio", value.value);
                              if (value.value !== "2633") {
                                setFieldValue("localidad", "");
                                setLocationDefault(null);
                              }
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.municipio && (
                            <div className="invalid-feedback d-block">
                              {errors.municipio}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Tipo de calle
                          </Form.Label>
                          <Select
                            className={`input-form ${
                              errors.colombusAddress?.roadType && "error"
                            }`}
                            options={roadTypes?.map((e) => ({
                              label: e.name,
                              value: e.id,
                            }))}
                            defaultValue={roadTypesDefault}
                            value={roadTypesDefault}
                            onChange={(e) => {
                              //console.log(e)
                              setRoadTypesDefault(e);
                              setFieldValue(
                                "colombusAddress.roadType",
                                e.value
                              );
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.colombusAddress?.roadType && (
                            <div className="invalid-feedback d-block">
                              {errors.colombusAddress?.roadType}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                          {" "}
                          No
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-control input-form ${
                            errors.colombusAddress?.streetField1 && "error"
                          }`}
                          name="colombusAddress.streetField1"
                        />
                        {errors.colombusAddress?.streetField1 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField1}
                          </div>
                        )}
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label className="font-weight-bold-600 text-secondary">
                        Número
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                            #
                          </InputGroup.Text>
                          <Field
                            type="text"
                            className={`form-control input-form ${
                              errors.colombusAddress?.streetField2 && "error"
                            }`}
                            name="colombusAddress.streetField2"
                          />
                        </InputGroup>
                        {errors.colombusAddress?.streetField2 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField2}
                          </div>
                        )}
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                          {" "}
                          No
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="border-right-0 rounded-0 input-group-text-rounded-0">
                            -
                          </InputGroup.Text>
                          <Field
                            type="text"
                            className={`form-control input-form ${
                              errors.colombusAddress?.streetField3 && "error"
                            }`}
                            name="colombusAddress.streetField3"
                          />
                        </InputGroup>
                        {errors.colombusAddress?.streetField3 && (
                          <div className="invalid-feedback d-block">
                            {errors.colombusAddress.streetField3}
                          </div>
                        )}
                      </Col>
                      <Col xs="12" md="2"></Col>

                      {municipioDefault?.value === 2633 && (
                        <Col xs="12" md="4">
                          <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary">
                              Localidad{" "}
                            </Form.Label>
                            <Select
                              className={`input-form ${
                                errors.localidad && "error"
                              }`}
                              options={localidadesOpt}
                              defaultValue={locationDefault}
                              value={locationDefault}
                              onChange={(value) => {
                                //console.log(e)
                                setLocationDefault(value);
                                setFieldValue("localidad", value.value);
                              }}
                              placeholder="Escoger opción"
                            />
                            {errors.localidad && (
                              <div className="invalid-feedback d-block">
                                {errors.localidad}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Barrio{" "}
                          </Form.Label>
                          <Field
                            type="text"
                            className={`form-control input-form`}
                            name="neighborhood"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="12"></Col>

                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Tipo de Inmueble{" "}
                          </Form.Label>
                          <Select
                            className={`input-form`}
                            options={propertyTypes?.map((e) => ({
                              label: e.name,
                              value: e.id,
                            }))}
                            defaultValue={propertyTypesDefault}
                            value={propertyTypesDefault}
                            onChange={(e) => {
                              setPropertyTypesDefault(e);
                              setFieldValue(
                                "colombusAddress.propertyType",
                                e.value
                              );
                            }}
                            placeholder="Escoger opción"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                          a
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-control input-form ${
                            errors.colombusAddress?.unitNumber && "error"
                          }`}
                          name="colombusAddress.unitNumber"
                        />
                      </Col>
                      <Col xs="12" md="4">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Bloque o Interior{" "}
                          </Form.Label>
                          <Select
                            className={`input-form`}
                            options={propertyTypes?.map((e) => ({
                              label: e.name,
                              value: e.id,
                            }))}
                            defaultValue={propertyTypesAdicionalDefault}
                            value={propertyTypesAdicionalDefault}
                            onChange={(e) => {
                              console.log(e);
                              setPropertyTypesAdicionalDefault(e);
                              setFieldValue(
                                "colombusAddress.propertyTypeAdditional",
                                e.value
                              );
                            }}
                            placeholder="Escoger opción"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="2">
                        <Form.Label className="font-weight-bold-600 text-secondary opacity-0">
                          a
                        </Form.Label>
                        <Field
                          type="text"
                          className={`form-control input-form ${
                            errors.colombusAddress?.propertyNumber && "error"
                          }`}
                          name="colombusAddress.propertyNumber"
                        />
                      </Col>

                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Tiposangre")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <ul className="mb-0 list-inline list-form">
                            <li
                              className={`${
                                tipoSangre === "O-" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("O-");
                                setFieldValue("bloodType", "O-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                O-
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "O+" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("O+");
                                setFieldValue("bloodType", "O+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                O+
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "A-" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("A-");
                                setFieldValue("bloodType", "A-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                A-
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "A+" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("A+");
                                setFieldValue("bloodType", "A+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                A+
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "AB-" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("AB-");
                                setFieldValue("bloodType", "AB-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                AB-
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "AB+" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("AB+");
                                setFieldValue("bloodType", "AB+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                AB+
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "B+" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("B+");
                                setFieldValue("bloodType", "B+");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                B+
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "B-" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("B-");
                                setFieldValue("bloodType", "B-");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                B-
                              </span>
                            </li>
                            <li
                              className={`${
                                tipoSangre === "desconocido" && "active"
                              } list-inline-item cursor-pointer`}
                              onClick={(e) => {
                                setTipoSangre("desconocido");
                                setFieldValue("bloodType", "desconocido");
                              }}
                            >
                              <span className="input-radio-custom text-color-input">
                                {t("Desconocido")}
                              </span>
                            </li>
                          </ul>
                          {errors.bloodType && (
                            <div className="invalid-feedback d-block">
                              {errors.bloodType}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("ocupacion")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className={`input-form ${
                              errors.ocupacion && "error"
                            }`}
                            options={ocupacionOpt}
                            defaultValue={ocupacionDefault}
                            value={ocupacionDefault}
                            onChange={(value) => {
                              //console.log(e)
                              setOcupacionDefault(value);
                              setFieldValue("ocupacion", value.value);
                            }}
                            placeholder="Escoger opción"
                          />
                          {errors.ocupacion && (
                            <div className="invalid-feedback d-block">
                              {errors.ocupacion}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("cuenta_cliente_corporativo")}{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            className="input-form"
                            options={accountsAll.map((e) => ({
                              label: e.name,
                              value: e.id,
                            }))}
                            defaultValue={accountDefault}
                            value={accountDefault}
                            onChange={(e) => {
                              setAccountdefault(e);
                              setFieldValue("account", e.value);
                            }}
                            menuPlacement="top"
                          />
                          {errors.account && (
                            <div className="invalid-feedback d-block">
                              {errors.account}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            Cliente corporativo{" "}
                          </Form.Label>
                          <div className="form-control input-form align-center">
                            {partnerDefault}
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("Idioma")} <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            className={`form-control input-form ${
                              errors.language && "error"
                            }`}
                            name="language"
                          >
                            <option value="">{t("Seleccionar")}</option>
                            {languageOpt.map((item, i) => (
                              <option value={item.id} key={i}>
                                {item.name}
                              </option>
                            ))}
                          </Field>
                          {errors.language && (
                            <div className="invalid-feedback d-block">
                              {errors.language}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs="12" md="6">
                        <Form.Group>
                          <Form.Label className="font-weight-bold-600 text-secondary">
                            {t("generar_cita")}
                          </Form.Label>
                          <div className="mt-3">
                            <label className="mr-5 text-color-input">
                              Manual
                              <input
                                name="generarCita"
                                type="radio"
                                className="ml-3 radio-form"
                                onChange={(e) => generarCita("manual")}
                              />
                            </label>
                            <label className="mr-5 text-color-input">
                              Autoagendamiento
                              <input
                                name="generarCita"
                                type="radio"
                                className="ml-3 radio-form"
                                onChange={(e) => generarCita("automatico")}
                              />
                            </label>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Row>
                  <Col className="text-right">
                    <Link
                      to={
                        isDoctor(auth.data.role) ||
                        isConsultorio(auth.data.role)
                          ? "/admin/doctors/patients"
                          : "/admin/patients"
                      }
                      className="btn btn-danger cancelar-buttom"
                    >
                      Cancelar
                    </Link>{" "}
                    <Button
                      variant="outline-success"
                      className="ok-buttom"
                      type="submit"
                    >
                      Aceptar
                    </Button>{" "}
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      )}

      <Modal show={show} onHide={handleClose} centered className="border-0">
        <Modal.Body>
          <div className="text-center position-relative overflow-hidden h-100p">
            <div className="text-center">
              <span className="d-block">
                <FaInfo className="text-info" />
              </span>
              <h5 className="mt-1 mb-0">
                Se le ha enviado el link para su autoagendamiento
              </h5>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showModalExpediente} onHide={handleCloseExpediente} centered>
        <Modal.Body className="overflow-hidden">
          {submitingA && <SimpleLoad />}
          <Form.Group>
            <Form.Label>No. expediente</Form.Label>
            <Form.Control
              className={`input-form ${expedienteDuplicado ? 'is-invalid' : ''}`}
              value={noExpediente}
              onChange={(e) => setNoExpediente(e.target.value)}
              disabled={checkingExpediente}
            />
            {checkingExpediente && (
              <Form.Text className="text-muted">
                Verificando expediente...
              </Form.Text>
            )}
            {expedienteDuplicado && (
              <Form.Text className="text-danger d-block">
                El expediente esta duplicado
              </Form.Text>
            )}
          </Form.Group>
          <div className="mt-3">
            <Button
              variant="outline-success"
              className="ok-buttom"
              type="button"
              onClick={sendAutoAgendamiento}
              disabled={expedienteDuplicado}
            >
              Aceptar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <ComponentModalErrorSever
        show={showModalError}
        handleClose={handleCloseServer}
        error={errorServer}
      />
      <ModalText
        show={modalEncontro}
        setShow={setModalEncontro}
        texto="Por favor verifica la información del formulario, si necesitas actualizar algún campo, puedes editarlo antes de continuar."
      />
    </Row>
  );
}

export default withTranslation()(FormPatientColombia);